import HeatingModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/HeatingModule";
import CoolingModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/CoolingModule";
import LightingModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/LightingModule";
import PlugLoadCookingModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/PlugLoadCookingModule";
import HotWaterModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/HotWaterModule";
import PoolSpaModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/PoolSpaModule";
import SolarPvModuleV001 from "../../Portal/Accessor/Module/V001/NewHome/SolarPvModule";
import ModuleSummary from "../../Portal/Accessor/Module/ModuleSummary";
const AccessorModuleNewHomeRouters = [
    {
        path: "HeatingAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <HeatingModuleV001/>,
        title: "Heating | AccuRate Enterprise",
    },
    {
        path: "CoolingAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <CoolingModuleV001/>,
        title: "Cooling | AccuRate Enterprise",
    },
    {
        path: "LightingAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <LightingModuleV001/>,
        title: "Lighting | AccuRate Enterprise",
    },
    {
        path: "PlugLoadAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <PlugLoadCookingModuleV001/>,
        title: "Plug Load & Cooking | AccuRate Enterprise",
    },
    {
        path: "HotWaterAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <HotWaterModuleV001/>,
        title: "Hot Water | AccuRate Enterprise",
    },
    {
        path: "PoolSpaAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <PoolSpaModuleV001/>,
        title: "Pool & Spa | AccuRate Enterprise",
    },
    {
        path: "SolarPvAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <SolarPvModuleV001/>,
        title: "Solar PV | AccuRate Enterprise",
    },
    {
        path: "ModuleSummaryAssessor/NewHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <ModuleSummary/>,
        title: "Summary | AccuRate Enterprise",
    },
];
export default AccessorModuleNewHomeRouters;